import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {Observable, Observer} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../components/shared/confirmation-dialog/confirmation-dialog.component';
import {UploadFileComponent} from '../components/upload-file/upload-file.component';

@Injectable({
  providedIn: 'root'
})
export class InterruptActionGuard implements CanDeactivate<UploadFileComponent> {

  constructor(private dialog: MatDialog) {
  }

  canDeactivate(component: UploadFileComponent ) {
    // Allow navigation if the component says that it is OK or it doesn't have a canDeactivate function
    if (component.processingStatus === undefined || !component.processingStatus.running) {
      return true;
    }

    return Observable.create((observer: Observer<boolean>) => {
      // UnsavedChangesDialog defined somewhere else and imported above
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: component.processingStatus.title,
          message: component.processingStatus.message,
          confirm: component.processingStatus.confirm,
          dismiss: component.processingStatus.dismiss
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          observer.next(true);
        } else {
          observer.next(false);
        }
        observer.complete();
      }, (error) => {
        observer.next(true);
        observer.complete();
      });
    });
  }


}
